import { AssetUrls } from 'config/assets';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CardsTableEmptyPlaceholder.css';

interface Props {
  onImportClick?: () => void;
}

export const CardsTableEmptyPlaceholder = ({ onImportClick }: Props) => {
  return (
    <div className="cards-table-empty-placeholder">
      <img
        src={AssetUrls.logos.arevakhachIcon}
        alt="send-icon"
        style={{ width: 45, height: 45 }}
      />
      <div className="cards-table-empty-placeholder-title">
        Nothing to see here yet...
      </div>
      <div className="cards-table-empty-placeholder-message">
        Try adding some cards to this list.
      </div>
      {onImportClick && (
        <button
          className="cards-table-empty-placeholder-import-btn"
          onClick={onImportClick}
        >
          <FontAwesomeIcon icon="file-import" />
          Import Cards
        </button>
      )}
    </div>
  );
};
